// @ts-nocheck
import get from "lodash.get";
import AbstractApiUtils from "services/cores/abstractApiUtils";
import MapUtils from "services/map/utils";
import ParkStatisticsUtils from "services/parkStatistics/utils";
import { DETAILS_API_TYPES } from "services/common/enums";

function getFilters(type = "default", state) {
  const { radius, position, include_is_unavailable } = state.GlobalFilters;
  const { areaType, timestamp } = state.ParkStatistics?.filters;
  const selectLayers =
    ParkStatisticsUtils.getSelectedLayers(state.ParkStatistics) || [];
  const floorLevel = MapUtils.getFloor(state.Map);
  let data = {};
  let filters = {};

  if (get(areaType, "length", 0) > 0) {
    filters = {
      area: {
        "type ($IN)": areaType,
      },
    };
  }

  if (type === "radius" && floorLevel !== null && floorLevel !== undefined) {
    filters = {
      ...filters,
      area: { ...get(filters, "area", {}), floor_level: floorLevel },
    };
  }

  if (type === "areas") {
    const allowedDetailsApiTypes = [DETAILS_API_TYPES.PARK];
    const areas = selectLayers
      .filter(
        (layer) =>
          floorLevel === undefined ||
          floorLevel === null ||
          get(layer, "floor_level") === floorLevel
      )
      ?.filter((layer) => allowedDetailsApiTypes.indexOf(layer.apiType) >= 0)
      .map((selectedLayer) => get(selectedLayer, "id"));

    if (areas.length > 0) {
      data = { ...data, areas };
    }
  }

  if (type === "radius") {
    data = { ...data, radius, position };
  }

  return {
    ...data,
    filters,
    timestamp,
    include_is_unavailable,
  };
}
class AvailableParkingUtils extends AbstractApiUtils {
  getFilters = getFilters;

  formatListFromApi = (list) => {
    return {
      items: get(list, "available_parking", []),
      others: {
        timestamp: this.getApiTimestamp(list),
      },
    };
  };

  isSpot = (type) => {
    const SPOT_TYPES = ["spot", "temporary_spot", "unavailable", "idle_spot"];
    return SPOT_TYPES.indexOf(type) >= 0;
  };
}

export { getFilters };
export default new AvailableParkingUtils();
